// // cart page block

// if (location.pathname === "/cart" && !location.search) {
//   window.location.href = "/?return_link=cart";
// }

// // Open cart drawer when redirected with ?return_link=cart
// if (new URLSearchParams(location.search).has("return_link")) {
//   const cartDrawerObserver = new MutationObserver(() => {
//     let cartDrawer = document.querySelector("cart-drawer");
//     if (cartDrawer) {
//       cartDrawer.show();
//       cartDrawerObserver.disconnect(); // Stop observing after cart opens
//     }
//   });
//   cartDrawerObserver.observe(document.body, { childList: true, subtree: true });

//   // Remove return_link=cart from the URL
//   const newUrl = location.href.replace(/[?&]return_link=cart/g, "");
//   history.replaceState({}, document.title, newUrl);
// }

// // Handle browser back button to close cart
// window.addEventListener("popstate", function (event) {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer && !location.search.includes("cartOpen=true")) {
//     cartDrawer.close();
//   } else if (event.state?.cart === "show" && cartDrawer) {
//     cartDrawer.show();
//   }
// });

// // Ensure cartOpen=true is removed from URL if cart is closed
// document.addEventListener("DOMContentLoaded", () => {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer && !cartDrawer.classList.contains("active")) {
//     const newUrl = location.href.replace(/[?&]cartOpen=true/g, "");
//     history.replaceState({}, document.title, newUrl);
//   }
// });

// // Open cart and push cartOpen=true into history
// function openCart() {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer) {
//     cartDrawer.show();
//     history.pushState({ cart: "show" }, "", "?cartOpen=true");
//   }
// }

// judgeme js
const ratingProductCard = document.querySelector(".rating-pdp-card");
const judgemeProductReviews = document.getElementById(
  "judgeme_product_reviews"
);
ratingProductCard?.addEventListener("click", function () {
  judgemeProductReviews.scrollIntoView({ behavior: "smooth" });
});

class RoundRating extends HTMLElement {
  constructor() {
    super();
    this.#init();
  }

  #init() {
    const value = parseFloat(this.textContent.trim());
    const roundedValue = Math.round(value * 10) / 10;
    this.textContent = roundedValue.toFixed(1);
  }
}

customElements.define("round-rating", RoundRating);

//round number

class RandomNumber extends HTMLElement {
  constructor() {
    super();
    // Include current URL path in storage key
    this.storageKey = `random-number-values-${window.location.pathname}`;

    // Initialize storage for this page if needed
    if (!sessionStorage.getItem(this.storageKey)) {
      sessionStorage.setItem(this.storageKey, JSON.stringify({}));
    }
  }

  generateUniqueId() {
    const allRandomNumbers = document.getElementsByTagName("random-number");
    for (let i = 0; i < allRandomNumbers.length; i++) {
      if (allRandomNumbers[i] === this) {
        return `random-number-${window.location.pathname}-${i}`;
      }
    }
    return `random-number-${window.location.pathname}-${Date.now()}`;
  }

  connectedCallback() {
    const min = parseInt(this.dataset.min) || 0;
    const max = parseInt(this.dataset.max) || 100;

    // Use element's ID or generate a stable one
    const elementId = this.getAttribute("id") || this.generateUniqueId();
    this.setAttribute("id", elementId);

    let storedValues = JSON.parse(sessionStorage.getItem(this.storageKey));

    // Generate new value only if it doesn't exist for this page
    if (!storedValues[elementId]) {
      const newValue = Math.floor(Math.random() * (max - min + 1)) + min;
      storedValues[elementId] = newValue;
      sessionStorage.setItem(this.storageKey, JSON.stringify(storedValues));
    }

    this.textContent = storedValues[elementId];
  }

  disconnectedCallback() {
    const elementId = this.getAttribute("id");
    const storedValues = JSON.parse(sessionStorage.getItem(this.storageKey));
    if (storedValues && elementId) {
      delete storedValues[elementId];
      // Only remove from storage if no more values exist for this page
      if (Object.keys(storedValues).length === 0) {
        sessionStorage.removeItem(this.storageKey);
      } else {
        sessionStorage.setItem(this.storageKey, JSON.stringify(storedValues));
      }
    }
  }
}
// Register the custom element
customElements.define("random-number", RandomNumber);

// cart-change-handler.js - OPTIMIZED
document.addEventListener("cart:change", debounce(async (event) => {
  const cartData = event.detail.cart;
  const baseEvent = event.detail.baseEvent;

  console.log("Base Event:", baseEvent);

  // First handle the case of removing add-ons when main product is gone
  const mainProducts = cartData.items.filter(
    (item) => !item.properties?._main_product
  );
  const addOns = cartData.items.filter(
    (item) => item.properties?._main_product
  );

  // If there are add-ons but no main products, remove ALL add-ons
  if (addOns.length > 0 && mainProducts.length === 0) {
    console.log(
      "No main products exist but add-ons found. Removing all add-ons."
    );
    await forceRemoveAllAddons(addOns);
    return; // Exit early after handling this case
  }

  // Check if any add-ons have a main product that no longer exists
  if (addOns.length > 0 && mainProducts.length > 0) {
    const orphanedAddons = addOns.filter((addon) => {
      // Find if this addon's main product still exists
      const mainProductExists = mainProducts.some(
        (main) => main.handle === addon.properties._main_product
      );
      return !mainProductExists;
    });

    if (orphanedAddons.length > 0) {
      console.log("Found orphaned add-ons to remove:", orphanedAddons);
      await forceRemoveAllAddons(orphanedAddons);
      return; // Exit early after handling this case
    }
  }

  // Handle changes to the main product quantity
  if (
    baseEvent === "line-item:change" ||
    baseEvent === "variant:add" ||
    baseEvent === "item:remove"
  ) {
    // For each main product
    for (const mainProduct of mainProducts) {
      // Find add-ons for this specific main product
      const relatedAddons = addOns.filter(
        (addon) => addon.properties._main_product === mainProduct.handle
      );

      if (relatedAddons.length === 0) continue;

      // If main product quantity is 0, remove all its add-ons
      if (mainProduct.quantity === 0) {
        console.log(
          `Main product ${mainProduct.handle} has 0 quantity. Removing all its add-ons.`
        );
        await forceRemoveAllAddons(relatedAddons);
        continue;
      }

      // For ready-to-wear, gift wrap, blouse customization, and remove-cups items, sync quantities
      const syncableAddons = relatedAddons.filter((addon) => {
        const isReadyToWear =
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("ready-to-wear")) ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("pre-drape")) ||
          (addon.variant_title &&
            addon.variant_title.toLowerCase().includes("ready-to-wear"));

        const isGiftWrap =
          addon.handle === "gift-wrapping" ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("gift wrap") &&
            !addon.product_title.toLowerCase().includes("gift box"));

        const isBlouseCustomization =
          addon.handle === "customise-blouse" ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("blouse customization")) ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("customise blouse"));

        const isRemoveCups =
          addon.handle === "remove-cups" ||
          (addon.product_title &&
            addon.product_title.toLowerCase().includes("remove cups"));

        return isReadyToWear || isGiftWrap || isBlouseCustomization || isRemoveCups;
      });

      if (syncableAddons.length > 0) {
        // Check if any addon needs its quantity updated
        const needsSync = syncableAddons.some(
          (addon) => addon.quantity !== mainProduct.quantity
        );

        if (needsSync) {
          console.log(
            `Syncing ${syncableAddons.length} add-ons for main product ${mainProduct.handle}`
          );
          await syncAddonQuantities(syncableAddons, mainProduct.quantity);
        }
      }
    }
  }

  if (baseEvent === "item:add" || baseEvent === "variant:add") {
    if (typeof window.triggerConfetti === 'function') {
      window.triggerConfetti({
        particleCount: 250,
        spread: 180,
        origin: { y: 1.0, x: 0.5 },
        startVelocity: 60,
        colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7']
      });
    }
  }

  // Check for gift-wrapping items
  checkAndRemoveGiftWrappingItems(cartData);

  // Reinitialize carousels after cart changes
  // Use a small timeout to ensure DOM updates from cart operations are complete
  setTimeout(() => {
    if (window.CustomCarousel && typeof CustomCarousel.reinitializeAll === 'function') {
      console.log("Reinitializing carousels");
      CustomCarousel.reinitializeAll();
    }
  }, 200);
  
}, 150)); // Debounce for 150ms to reduce frequency

// Utility function for debouncing
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Helper function to force remove all add-ons (sets quantity to 0)
async function forceRemoveAllAddons(addons) {
  if (!addons || addons.length === 0) return;

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Build updates object with all quantities set to 0
    const updates = {};
    addons.forEach((addon) => {
      updates[addon.key] = 0;
    });

    console.log("Removing add-ons with updates:", updates);

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) throw new Error("Failed to update cart");

    const updatedCartContent = await response.json();
    console.log("Cart updated after removing add-ons:", updatedCartContent);

    // Dispatch cart change event to update the UI
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "item:remove",
          cart: updatedCartContent,
        },
      })
    );

    // Update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("Error removing add-ons:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}

// Helper function to sync addon quantities
async function syncAddonQuantities(addons, newQuantity) {
  if (!addons || addons.length === 0) return;

  document.documentElement.dispatchEvent(
    new CustomEvent("theme:loading:start", { bubbles: true })
  );

  try {
    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    // Update all addons to the new quantity
    const updates = {};
    addons.forEach((addon) => {
      updates[addon.key] = newQuantity;
    });

    console.log("Syncing addons with updates:", updates);

    const response = await fetch(
      `${window.Shopify.routes.root}cart/update.js`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      }
    );

    if (!response.ok) throw new Error("Failed to update cart");

    const updatedCartContent = await response.json();
    console.log("Cart updated after syncing addons:", updatedCartContent);

    // Rebuild cart UI
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "item:update",
          cart: updatedCartContent,
        },
      })
    );

    // Force update cart UI
    const cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cart && typeof cart.renderContents === "function") {
      cart.renderContents(updatedCartContent);
    }
  } catch (error) {
    console.error("Error syncing addon quantities:", error);
  } finally {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true })
    );
  }
}

// window.initializeVideoControls = function () {
//   const video = document.querySelector(".video-element");
//   if (!video) return;

//   const muteToggle = document.getElementById("mute-toggle");
//   if (!muteToggle) return;

//   const unmuteText = muteToggle.querySelector(".unmute-text");
//   const muteText = muteToggle.querySelector(".mute-text");

//   // Toggle mute/unmute when the button is clicked
//   muteToggle.addEventListener("click", function () {
//     video.muted = !video.muted;

//     // Toggle button text
//     if (video.muted) {
//       unmuteText.style.display = "inline";
//       muteText.style.display = "none";
//     } else {
//       unmuteText.style.display = "none";
//       muteText.style.display = "inline";
//     }
//   });

//   // Toggle play/pause on video click
//   video.addEventListener("click", function () {
//     this.paused ? this.play() : this.pause();
//   });
// };

// // Initialize video controls if video element exists
// if (document.querySelector(".video-element")) {
//   window.initializeVideoControls();
// }

// Size Chart Toggle in inches and cms
if (document.querySelector(".toggle-tab-inches-cm")) {
  window.handleSizeToggle();
}

// typewriter component
class TypewriterComponent extends HTMLElement {
  constructor() {
    super();
    this.texts = Array.from(this.querySelectorAll("p")).map(
      (message) => message.innerHTML
    );
    this.currentTextIndex = 0;
    this.currentCharIndex = 0;
    this.isDeleting = false;
    this.typeSpeed = 100; // Adjust typing speed (in milliseconds)
    this.deleteSpeed = 50; // Adjust deleting speed (in milliseconds)
    this.pauseBetweenTexts = 2000; // Pause between texts (in milliseconds)
    this.type();
  }

  type() {
    const currentText = this.texts[this.currentTextIndex];
    const displayText = this.isDeleting
      ? currentText.substring(0, this.currentCharIndex - 1)
      : currentText.substring(0, this.currentCharIndex + 1);

    this.innerHTML = displayText;

    if (!this.isDeleting) {
      this.currentCharIndex++;
      if (this.currentCharIndex === currentText.length) {
        this.isDeleting = true;
        setTimeout(() => this.type(), this.pauseBetweenTexts);
      } else {
        setTimeout(() => this.type(), this.typeSpeed);
      }
    } else {
      this.currentCharIndex--;
      if (this.currentCharIndex === 0) {
        this.isDeleting = false;
        this.currentTextIndex = (this.currentTextIndex + 1) % this.texts.length;
        setTimeout(() => this.type(), this.typeSpeed);
      } else {
        setTimeout(() => this.type(), this.deleteSpeed);
      }
    }
  }
}

customElements.define("typewriter-component", TypewriterComponent);

// Read more collection description
if (document.querySelector(".collection-description")) {
  setupReadMore();
}

// Add this function to check and remove gift-wrapping items when they're alone in cart
function checkAndRemoveGiftWrappingItems(cartData) {
  // Check if cart has items
  if (!cartData || !cartData.items || cartData.items.length === 0) return;

  // If there's only gift-wrapping items in the cart, remove them
  const giftWrappingItems = cartData.items.filter(
    (item) =>
      item.handle === "gift-wrapping" ||
      item.product_title.toLowerCase().includes("gift wrap")
  );

  // If all items are gift-wrapping items, remove them
  if (
    giftWrappingItems.length > 0 &&
    giftWrappingItems.length === cartData.items.length
  ) {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    try {
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      // Prepare updates to set gift-wrapping quantities to 0
      const updates = giftWrappingItems.reduce((acc, item) => {
        acc[item.key] = 0;
        return acc;
      }, {});

      // Update cart to remove gift-wrapping items
      fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({
          updates,
          sections: sectionsToBundle.join(","),
          sections_url: window.location.pathname,
        }),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Failed to update cart");
          return response.json();
        })
        .then((updatedCartContent) => {
          // Dispatch cart change event to update the UI
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "item:remove",
                cart: updatedCartContent,
              },
            })
          );

          // Update cart UI
          const cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
        })
        .catch((error) => {
          console.error("Error removing gift-wrapping items:", error);
          if (window.themeVariables?.settings.showErrorMessage) {
            alert(error.message);
          }
        })
        .finally(() => {
          document.documentElement.dispatchEvent(
            new CustomEvent("theme:loading:end", { bubbles: true })
          );
        });
    } catch (error) {
      console.error("Error checking gift-wrapping items:", error);
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
    }
  }
}

// section scroller
class SectionScroller extends HTMLElement {
  constructor() {
    super();
    this.isAtTop = true;
    this.topThreshold = 80; // Set threshold to 80px
    this.addEventListener("click", this.handleClick);
    window.addEventListener("scroll", this.handleScroll.bind(this));
    this.handleScroll(); // Initialize state on load
    this.updateArrowDirection();
    // Add double tap tracking
    this.lastTapTime = 0;
    this.doubleTapDelay = 300; // 300ms between taps to count as double-tap
  }

  handleClick() {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - this.lastTapTime;

    // Check for double tap
    if (!this.isAtTop && tapLength < this.doubleTapDelay && tapLength > 0) {
      // Double tap detected - scroll to viewport top
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.isAtTop = true;
      this.updateArrowDirection();

      // Reset tap tracking
      this.lastTapTime = 0;
      return;
    }

    // Save the tap time for potential double tap detection
    this.lastTapTime = currentTime;

    // Normal single tap behavior
    if (this.isAtTop) {
      // If at top, scroll to featured categories section
      const featuredSection =
        document.querySelector(
          ".featured-categories-max-width, .product-discount-carousel"
        ) || document.querySelector(".shopify-section--related-products");
      if (featuredSection) {
        featuredSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        this.isAtTop = false;
        this.updateArrowDirection();
      }
    } else {
      // Check if we're below the apps section
      const appsSection = document.querySelector(".jdgm-carousel-title");
      if (
        appsSection &&
        window.scrollY > appsSection.offsetTop + appsSection.offsetHeight
      ) {
        // If below apps section, scroll directly to featured categories
        const featuredSection = document.querySelector(
          ".featured-categories-max-width"
        );
        if (featuredSection) {
          featuredSection.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      } else {
        // Otherwise use the existing functionality
        this.scrollToNearestSectionUp();
      }
    }
  }

  handleScroll() {
    // Check if we're within the "top" threshold (80px)
    if (window.scrollY < this.topThreshold) {
      this.isAtTop = true;
    } else {
      this.isAtTop = false;
    }
    this.updateArrowDirection();
  }

  updateArrowDirection() {
    if (this.isAtTop) {
      this.style.transform = "rotateZ(180deg)";
    } else {
      this.style.transform = "rotateZ(0deg)";
    }
  }

  scrollToNearestSectionUp() {
    // Get all section elements
    const sections = Array.from(
      document.querySelectorAll(
        "section, [data-section-type], [data-section-id]"
      )
    );

    // Get current scroll position
    const scrollPos = window.scrollY;

    // Find the nearest section above the current position
    let targetSection = null;
    let closestDistance = Number.MAX_SAFE_INTEGER;

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const distance = scrollPos - sectionTop;

      // Only consider sections above current position (distance > 0)
      if (distance > 0 && distance < closestDistance) {
        closestDistance = distance;
        targetSection = section;
      }
    });

    // Scroll to the target section if found
    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      // If no section found above, scroll to top
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.isAtTop = true;
      this.updateArrowDirection();
    }
  }
}

// Register the custom element
customElements.define("section-scroller", SectionScroller);

class BottomCart extends HTMLElement {
  constructor() {
    super();
    this.cartUpdateHandler = this.handleCartUpdate.bind(this);
    this.bundleSectionsHandler = this.handleBundleSections.bind(this);
    this.refreshCartHandler = this.handleRefreshCart.bind(this);
  }

  connectedCallback() {
    // Add event listeners
    document.addEventListener("cart:change", this.cartUpdateHandler);
    document.addEventListener(
      "cart:prepare-bundled-sections",
      this.bundleSectionsHandler
    );
    document.addEventListener("cart:refresh", this.refreshCartHandler);
  }

  disconnectedCallback() {
    // Remove event listeners
    document.removeEventListener("cart:change", this.cartUpdateHandler);
    document.removeEventListener(
      "cart:prepare-bundled-sections",
      this.bundleSectionsHandler
    );
    document.removeEventListener("cart:refresh", this.refreshCartHandler);
  }

  handleBundleSections(event) {
    // Add this section's ID to the sections that should be updated
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );
    event.detail.sections.push(sectionId);
  }

  handleCartUpdate(event) {
    const cartData = event.detail.cart;
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    // Get the updated HTML for this section
    const sectionHtml = cartData.sections[sectionId];

    if (sectionHtml) {
      // Parse and update the section content
      const domElement = new DOMParser().parseFromString(
        sectionHtml,
        "text/html"
      );
      const newContent = domElement.querySelector("bottom-cart").innerHTML;
      this.innerHTML = newContent;
    }
  }

  async handleRefreshCart() {
    const sectionId = this.closest(".shopify-section").id.replace(
      "shopify-section-",
      ""
    );

    // Fetch the latest cart section HTML
    const response = await fetch(
      `${window.Shopify.routes.root}?section_id=${sectionId}`
    );
    const html = await response.text();

    // Parse and update the section content
    const domElement = new DOMParser().parseFromString(html, "text/html");
    const newContent = domElement.querySelector("bottom-cart").innerHTML;
    this.innerHTML = newContent;
  }
}

// Register the custom element if it hasn't been registered yet
if (!customElements.get("bottom-cart")) {
  customElements.define("bottom-cart", BottomCart);
}

// Confetti function for celebrations
window.triggerConfetti = function(options = {}) {
  // Default options
  const defaultOptions = {
    particleCount: 200,
    spread: 180,
    origin: { y: 1.0, x: 0.5 },
    startVelocity: 50,
    colors: ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7']
  };
  
  // Merge with passed options
  const confettiOptions = { ...defaultOptions, ...options };
  
  if (typeof confetti === 'function') {
    confetti(confettiOptions);
  } else {
    // Wait for confetti library to load
    const maxWait = 3000; // 3 seconds max
    const interval = 100; // Check every 100ms
    let waited = 0;
    
    const checkConfetti = setInterval(() => {
      if (typeof confetti === 'function') {
        clearInterval(checkConfetti);
        confetti(confettiOptions);
      } else if (waited >= maxWait) {
        clearInterval(checkConfetti);
        console.log('Confetti library failed to load');
      }
      waited += interval;
    }, interval);
  }
};

function deleteCookie(name) {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

// Function to clear the discount code cookie
function clearDiscountCodeCookie() {
  deleteCookie('cart');
  console.log('Discount code cookie cleared.');
}

// Run clearDiscountCodeCookie only once per browser
if (!localStorage.getItem('discountCookieCleared')) {
  clearDiscountCodeCookie();
  localStorage.setItem('discountCookieCleared', 'true');
}

// cross sell product card

class CrossSellProductCard extends HTMLElement {
  constructor() {
    super();
    this.quickBuyId = this.getAttribute('quick-buy-id');
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    const checkbox = this.querySelector('.cross-sell-product-card__checkbox');
    const addButton = this.querySelector('.cross-sell-product-card__add-button');
    const viewButton = this.querySelector('.cross-sell-product-card__view-button');

    // Handle checkbox change for single variant products
    if (checkbox) {
      checkbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          const variantId = e.target.getAttribute('data-variant-id');
          this.addToCart(variantId);
        }
      });
    }

    // Handle add button click for multi-variant products
    if (addButton) {
      addButton.addEventListener('click', () => {
        this.openQuickBuy();
      });
    }

    // Handle view button click
    if (viewButton) {
      viewButton.addEventListener('click', () => {
        this.openQuickBuy();
      });
    }
  }

  openQuickBuy() {
    const quickBuyModal = this.querySelector('.quick-buy-modal') || document.getElementById(this.quickBuyId);
    if (quickBuyModal && quickBuyModal.show) {
      quickBuyModal.show();
    }
  }

  async addToCart(variantId) {
    // Disable checkbox during request
    const checkbox = this.querySelector('.cross-sell-product-card__checkbox');
    if (checkbox) {
      checkbox.disabled = true;
    }

    try {
      // Prepare sections for cart update (following existing pattern)
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );
      
      document.body.classList.add('loading-spinner');

      // Add to cart using the same format as existing system
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1
          }],
          sections: sectionsToBundle.join(','),
          sections_url: window.location.pathname,
        }),
      });

      const responseJson = await response.json();

      if (response.ok) {
        // Get updated cart content
        const cartContent = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        // Dispatch variant:add event (following existing pattern)
        document.documentElement.dispatchEvent(
          new CustomEvent('variant:add', {
            bubbles: true,
            detail: {
              items: responseJson.items || [responseJson],
              cart: cartContent,
            },
          })
        );

        // Dispatch cart:change event (following existing pattern)
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent,
            },
          })
        );

        // Remove the cross-sell card with animation
        this.style.animation = 'fadeOut 0.3s ease-out forwards';
        setTimeout(() => {
          this.remove();
        }, 300);

      } else {
        throw new Error(responseJson.description || 'Failed to add to cart');
      }
    } catch (error) {
      console.error('Error adding to cart:', error);
      // Re-enable checkbox and reset state
      if (checkbox) {
        checkbox.disabled = false;
        checkbox.checked = false;
      }
      
      // Show error feedback
      alert(error.message || 'Failed to add product to cart. Please try again.');
    }
    finally {
      document.body.classList.remove('loading-spinner');
    }
  }
}

// Define the custom element
customElements.define('cross-sell-product-card', CrossSellProductCard);